export const products = [
  {
    id: 1,
    name: 'NexusFlow',
    description:
      'A business automation platform that streamlines operations, integrates workflows, and reduces manual processes through intelligent task orchestration.',
    image: 'https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/adacc5a9d64b18f03e1a9fff21480458.png',
  },
  {
    id: 2,
    name: 'Vertex CRM',
    description:
      'A powerful customer relationship management system designed to help businesses track leads, automate sales pipelines, and improve customer retention.',
    image: 'https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/71d26e998e7d832333788d67885cd30e.png',
  },
  {
    id: 3,
    name: 'AdScale AI',
    description:
      'An AI-driven marketing optimization platform that analyzes campaigns, improves targeting, and maximizes ROI across multiple advertising channels.',
    image: 'https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/262974283e4034fca5a6d570fe872003.png',
  },
  {
    id: 4,
    name: 'DataPulse',
    description:
      'A real-time analytics dashboard that transforms complex business data into clear, actionable insights for faster decision-making.',
    image: 'https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/31748058186bb7d3b96fb26af968ebb7.png',
  },
  {
    id: 5,
    name: 'CloudBridge',
    description:
      'A cloud infrastructure management solution that simplifies deployment, scaling, and monitoring across multiple environments.',
    image: 'https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/ad4b5e38c99f2893c66b21ca87663c55.png',
  },
  {
    id: 6,
    name: 'LaunchKit',
    description:
      'An all-in-one product launch platform that helps startups go from idea to market with integrated tools for development, analytics, and growth.',
    image: 'https://static.readdy.ai/image/b83d215482d53eb69b064b5c4f8c0569/fe4ff9a2f752affaefe9706919aa1f31.png',
  },
];